// Add to cart from a product card (landing pages, Sean 9/22).
// Swatch clicks on these cards select in place (theme.js would open the quick-buy modal:
// intercepted in the capture phase); the button posts the selected variant and opens the
// drawer, so the offer engine arms whatever the session earns.
(function () {
  'use strict';
  function card(el) { return el && el.closest && el.closest('.product-block--card-atc'); }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.product-block--card-atc .color-swatch-icon');
    if (!sw) return;
    e.preventDefault(); e.stopPropagation();
    var c = card(sw); if (!c) return;
    c.querySelectorAll('.color-swatch-icon').forEach(function (x) { x.classList.remove('is-selected'); });
    sw.classList.add('is-selected');
    var btn = c.querySelector('[data-card-atc]');
    if (btn && sw.dataset.variantId) { btn.dataset.variantId = sw.dataset.variantId; var out = sw.classList.contains('unavailable'); btn.disabled = out; btn.textContent = out ? 'Sold out' : 'Add to cart'; }
    var img = c.querySelector('.image__first img'); var src = sw.dataset.variantImage;
    if (img && src) { var w = img.getAttribute('width') || 600; img.src = src.replace('{width}', w); img.srcset = ''; }
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-card-atc]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = parseInt(btn.dataset.variantId, 10); if (!id) return;
    btn.classList.add('is-busy'); var label = btn.textContent; btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed ' + r.status); return r.json(); })
      .then(function (res) { document.dispatchEvent(new CustomEvent('cart:add', { detail: res })); document.dispatchEvent(new Event('cart:open')); btn.textContent = 'Added'; setTimeout(function () { btn.textContent = label; }, 1500); })
      .catch(function (err) { console.error('[card-atc]', err); btn.textContent = 'Try again'; setTimeout(function () { btn.textContent = label; }, 2000); })
      .then(function () { btn.classList.remove('is-busy'); });
  });
})();
